import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";
export interface MenuHeader {
  tid: number;
  name: string;
  field_malay_title: string;
  field_mandarin_title: string;
  field_common_image: string;
  field_category: string;
  published: boolean;
  publish: boolean;
}

const fetchData = async <T>(url: string): Promise<T> => {
  const response = await eramanCMSApi.get<T>(url);
  console.log("fetchData", response, url);
  return response.data;
};

export const createDataHook =
  <T>(key: string, url: string) =>
  (
    options?: UseQueryOptions<T, DefaultError, T, QueryKey>,
    queryClient?: QueryClient
  ): UseQueryResult<T, DefaultError> => {
    return useQuery<T, DefaultError, T, QueryKey>(
      {
        queryKey: [key],
        enabled: false,
        queryFn: () => fetchData<T>(url),
        refetchOnWindowFocus: false,
        ...options,
      },
      queryClient
    );
  };

export const createDataHooksForPages =
  <T>(key: string, getUrl: (listId: string) => string) =>
  (
    listId: string,
    options?: UseQueryOptions<T, DefaultError, T, QueryKey>,
    queryClient?: QueryClient
  ): UseQueryResult<T, DefaultError> => {
    return useQuery<T, DefaultError, T, QueryKey>(
      {
        queryKey: [key, listId],
        enabled: false,
        queryFn: () => fetchData<T>(getUrl(listId)),
        refetchOnWindowFocus: false,
        ...options,
      },
      queryClient
    );
  };

const useMenuHeader = createDataHooksForPages<MenuHeader[]>(
  "menuHeader",
  (listId) => `/api/menuheaders/all-fields/${listId}`
);

export { useMenuHeader };
